export default __webpack_public_path__ + "static/navbar-asset-553c4504c0729bc779aa9679a8dfac89.webp";